// Native Shopify cart (AJAX Cart API) + slide-in drawer.
// Replaces the localStorage CartProvider/CartView from the Next.js app.
(function () {
  var CURRENCY = window.cryocapCurrency || "EUR";
  var LOCALE = window.cryocapLocale || "de-DE";
  var fmt = new Intl.NumberFormat(LOCALE, { style: "currency", currency: CURRENCY });
  var money = function (cents) { return fmt.format((cents || 0) / 100); };

  var overlay, drawer, body, foot, badges;

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function ensureDom() {
    overlay = qs("#cart-drawer-overlay");
    drawer = qs("#cart-drawer");
    if (!drawer) return false;
    body = qs(".cd-body", drawer);
    foot = qs(".cd-foot", drawer);
    return true;
  }

  function open() { if (drawer) { overlay.classList.add("open"); drawer.classList.add("open"); document.body.style.overflow = "hidden"; } }
  function close() { if (drawer) { overlay.classList.remove("open"); drawer.classList.remove("open"); document.body.style.overflow = ""; } }

  function setCount(n) {
    qsa(".cart-badge").forEach(function (b) {
      b.textContent = n;
      if (n > 0) { b.removeAttribute("hidden"); } else { b.setAttribute("hidden", ""); }
    });
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cd-empty">Ihr Warenkorb ist leer.</div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image + '" alt="' + (it.product_title || "") + '">' : '<span></span>';
      var variant = (it.variant_title && it.variant_title !== "Default Title") ? '<div class="cd-variant">' + it.variant_title + "</div>" : "";
      return '<div class="cd-item" data-line="' + (i + 1) + '">' +
        img +
        '<div>' +
          '<div class="cd-name">' + it.product_title + "</div>" +
          variant +
          '<div class="qty">' +
            '<button type="button" data-cart-minus aria-label="Menge verringern">−</button>' +
            '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-cart-qty readonly>' +
            '<button type="button" data-cart-plus aria-label="Menge erhöhen">+</button>' +
          "</div>" +
        "</div>" +
        '<div><div class="ci-price">' + money(it.final_line_price) + "</div>" +
        '<button type="button" class="cd-remove" data-cart-remove>Entfernen</button></div>' +
      "</div>";
    }).join("");
    qs(".cd-subtotal span:last-child", foot).textContent = money(cart.total_price);
  }

  function refresh() {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function change(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); return cart; });
  }

  // Public: add to cart (used by product form)
  window.cryocapAddToCart = function (id, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function (cart) { open(); return cart; });
  };

  document.addEventListener("DOMContentLoaded", function () {
    if (!ensureDom()) { return; }

    overlay.addEventListener("click", close);
    qsa("[data-cart-close]").forEach(function (b) { b.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    // Header cart icon opens the drawer (works on every page).
    qsa(".cart-link").forEach(function (link) {
      link.addEventListener("click", function (e) {
        // On the cart page itself, let the link navigate normally.
        if (link.dataset.drawer === "false") return;
        e.preventDefault();
        refresh().then(open);
      });
    });

    // Drawer line-item controls (delegated).
    body.addEventListener("click", function (e) {
      var item = e.target.closest(".cd-item");
      if (!item) return;
      var line = parseInt(item.getAttribute("data-line"), 10);
      var input = qs("[data-cart-qty]", item);
      var current = parseInt(input.value, 10) || 1;
      if (e.target.closest("[data-cart-plus]")) change(line, current + 1);
      else if (e.target.closest("[data-cart-minus]")) change(line, Math.max(0, current - 1));
      else if (e.target.closest("[data-cart-remove]")) change(line, 0);
    });

    refresh();
  });
})();
